/* christina-filters.js — R8C (2026-08-05)
   Przeniesione z inline <script> w snippets/christina-filters-enhance.liquid
   (7 643 B w kazdym dokumencie). Ladowane defer i WYLACZNIE tam, gdzie sa filtry.
   Dodane: guard __ccFilters, warstwa prezentacyjna i18n (patrz nizej). */
(function() {
  'use strict';

  /* R8C: guard — snippet moze zostac wyrenderowany ponownie przez Theme Editor. */
  if (window.__ccFilters) return;
  window.__ccFilters = 1;

  /* ── R8C: WARSTWA PREZENTACYJNA I18N ────────────────────────────────────
     Teksty UI i etykiety filtrow byly zaszyte po polsku i wyciekaly na /en/
     oraz /zh/. Teraz przychodza z Liquid przez window.__ccFiltersCfg.
     ZASADA: tlumaczymy WYLACZNIE warstwe widoczna. Nie ruszamy `input.value`,
     `input.name`, parametrow URL ani licznikow — kanoniczne wartosci metapol
     zostaja nietkniete. Wartosc nieznana w mapie => zostaje kanoniczna. */
  var CFG = window.__ccFiltersCfg || {};
  var T   = CFG.ui || {};
  var MAP = CFG.labels || {};
  function t(key, fallback) {
    return (typeof T[key] === 'string' && T[key].length) ? T[key] : fallback;
  }
  /* Zwraca przetlumaczona etykiete albo kanoniczna, gdy brak wpisu w mapie. */
  function trLabel(canonical) {
    var k = (canonical || '').trim();
    return Object.prototype.hasOwnProperty.call(MAP, k) ? MAP[k] : canonical;
  }
  /* Podmienia TYLKO wezly tekstowe etykiety, zostawiajac <span> z licznikiem.
     Kanoniczna wartosc zapamietujemy w data-cc-canon, wiec funkcja jest
     idempotentna i przezywa re-render AJAX-owy (drugie wywolanie czyta
     oryginal, nie wlasny wynik). */
  function localizeLabels(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.facet-form .list label, .active-facets .removable-facet, .facet-form details summary .text-base-xl');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var textNode = null;
      for (var j = 0; j < el.childNodes.length; j++) {
        var n = el.childNodes[j];
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim().length) { textNode = n; break; }
      }
      if (!textNode) continue;
      var canon = el.getAttribute('data-cc-canon');
      if (canon === null) {
        canon = textNode.nodeValue.trim();
        el.setAttribute('data-cc-canon', canon);
      }
      var out = trLabel(canon);
      var lead = textNode.nodeValue.match(/^\s*/)[0];
      var tail = textNode.nodeValue.match(/\s*$/)[0];
      if (textNode.nodeValue !== lead + out + tail) textNode.nodeValue = lead + out + tail;
    }
  }

  // ============ CHRISTINA FILTERS JS ============

  // 1. Inject sticky CTA in mobile drawer
  function injectMobileCTA() {
    const drawer = document.getElementById('MobileFacetFiltersContainer');
    if (!drawer) return;
    if (drawer.querySelector('.cf-mobile-cta')) return; // already exists

    const cta = document.createElement('div');
    cta.className = 'cf-mobile-cta';
    cta.innerHTML = `
      <button type="button" class="cf-mobile-cta-btn cf-mobile-cta-btn--clear" data-action="cf-clear">${t('clear','Wyczyść')}</button>
    `;
    drawer.appendChild(cta);

    // Wire up actions
    cta.querySelector('[data-action="cf-clear"]').addEventListener('click', function() {
      // Clear all by clicking the existing "clear all" link
      const clearLink = drawer.querySelector('.facet-clear-all');
      if (clearLink) {
        clearLink.click();
      } else {
        // Reset URL to base collection
        if (window.location.search) {
          window.location.href = window.location.pathname;
        }
      }
    });

    /* T-MOD10 (2026-10-31): natywny przycisk motywu "Zobacz wyniki (N)" zostaje jedynym zatwierdzeniem; drugi przycisk go powielal. */
  }

  // 2. Track active filter count and update mobile filter button badge
  function updateActiveFilterBadge() {
    const filterBtns = document.querySelectorAll('button[aria-controls="MobileFacetFiltersContainer"], button[aria-controls*="FilterDrawer"]');
    if (!filterBtns.length) return;

    // Count active facets from URL params
    const params = new URLSearchParams(window.location.search);
    let activeCount = 0;
    for (const [key] of params) {
      if (key.startsWith('filter.')) activeCount++;
    }

    filterBtns.forEach(function(btn) {
      // Remove existing badge
      const existing = btn.querySelector('.cf-active-count');
      if (existing) existing.remove();

      if (activeCount > 0) {
        btn.setAttribute('data-active-filters', 'true');
        const badge = document.createElement('span');
        badge.className = 'cf-active-count';
        badge.textContent = activeCount;
        btn.appendChild(badge);
      } else {
        btn.removeAttribute('data-active-filters');
      }
    });
  }

  // 3. Empty state recovery — when collection has 0 results
  function initEmptyStateRecovery() {
    // Check if product grid is empty
    const grid = document.querySelector('.product-grid, [data-product-grid], product-grid');
    if (!grid) return;

    const products = grid.querySelectorAll('product-card, [data-product-card]');
    if (products.length > 0) return; // not empty

    // Check if active filters exist
    const hasFilters = window.location.search.includes('filter.');
    if (!hasFilters) return;

    // Check if hint already exists
    if (document.querySelector('.cf-empty-hint')) return;

    // Inject hint
    const hint = document.createElement('div');
    hint.className = 'cf-empty-hint';
    hint.innerHTML = `
      <h3 class="cf-empty-hint__title">${t('emptyTitle','Brak wyników dla wybranych filtrów')}</h3>
      <p class="cf-empty-hint__text">${t('emptyText','Spróbuj usunąć niektóre filtry lub zmienić zakres ceny.')}</p>
      <a href="${window.location.pathname}" class="cf-empty-hint__action">${t('emptyCta','Wyczyść wszystkie filtry')}</a>
    `;
    grid.parentNode.insertBefore(hint, grid);
  }

  // 4. Keyboard shortcut "F" opens filter drawer (mobile) or focuses filter form (desktop)
  // R7-A4: bind tylko raz — init() jest wołany ponownie po każdej filtracji,
  // wcześniej każde wywołanie dokładało kolejny listener keydown na document.
  var keyboardBound = false;
  function initKeyboardShortcut() {
    if (keyboardBound) return;
    keyboardBound = true;
    document.addEventListener('keydown', function(e) {
      // Ignore if user is typing
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
        return;
      }
      if ((e.key === 'f' || e.key === 'F') && !e.metaKey && !e.ctrlKey && !e.altKey && !e.shiftKey) {
        const filterBtn = document.querySelector('button[aria-controls="MobileFacetFiltersContainer"]');
        if (filterBtn && getComputedStyle(filterBtn).display !== 'none') {
          e.preventDefault();
          filterBtn.click();
        } else {
          // Desktop: focus first filter
          const firstCheckbox = document.querySelector('.facet-form input[type="checkbox"]:not(:disabled)');
          if (firstCheckbox) {
            e.preventDefault();
            firstCheckbox.focus();
          }
        }
      }
    });
  }

  // 5. Pulse animation on filter change (count update)
  // R7-A4: był leak — init() po każdej filtracji tworzył NOWY MutationObserver
  // i podpinał go do ~64 pojedynczych spanów (2 formularze x 32 liczniki), nigdy
  // go nie rozłączając. Do tego theme podmienia innerHTML grupy, więc stare
  // obserwatory obserwowały już usunięte węzły. Teraz: JEDEN obserwator na
  // kontener formularzy, z disconnect() przed ponownym podpięciem.
  var countObserver = null;
  function watchCountChanges() {
    if (countObserver) { countObserver.disconnect(); countObserver = null; }

    const scopes = [];
    ['FacetFiltersContainer', 'MobileFacetFiltersContainer'].forEach(function(id) {
      const el = document.getElementById(id);
      if (el) scopes.push(el);
    });
    if (!scopes.length) return;

    countObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type !== 'characterData' && mutation.type !== 'childList') return;
        const node = mutation.target;
        const target = (node.nodeType === 1 ? node : node.parentElement);
        if (target && target.classList && target.classList.contains('text-opacity')) {
          target.classList.add('cf-count-changed');
          setTimeout(function() {
            target.classList.remove('cf-count-changed');
          }, 350);
        }
      });
    });

    scopes.forEach(function(el) {
      countObserver.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // Init
  function init() {
    if (!document.querySelector('.facet-form')) return; // not on a page with filters

    localizeLabels();
    injectMobileCTA();
    updateActiveFilterBadge();
    initEmptyStateRecovery();
    initKeyboardShortcut();
    watchCountChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after page transitions (Shopify section re-renders)
  document.addEventListener('shopify:section:load', init);
  // Hook into Shopify facet form events if they exist
  document.addEventListener('facet:rendered', function() {
    setTimeout(init, 100);
  });
  // R7-A4: motyw po filtracji emituje 'collection:reloaded' (collection.js
  // afterRenderSection). Bez tego licznik aktywnych filtrów zostawał nieaktualny.
  // Wszystkie funkcje init() są idempotentne (guard + disconnect), więc powtórne
  // wywołanie nie dokłada listenerów.
  document.addEventListener('collection:reloaded', init);
})();
